import { SearchProps } from '~components/form-fields/search';

import { selectLookupFundingTypes } from '~support-at-home/selectors/fundingTypes';
import { isEncryptionEnabled } from '~libs/encryptionSettings';

export const searchFields: SearchProps = {
  client: {
    defaultShow: true,
    type: 'text-like',
    field: ['first_name', 'surname'],
    placeholder: 'Client Name',
    caption: 'Client',
    hidden: isEncryptionEnabled,
  },
  with_budget: {
    defaultShow: true,
    type: 'lookup',
    field: 'with_budget',
    caption: 'Budget Status',
    placeholder: 'Select Budget Status',
    options: [
      { id: '', name: 'All Clients' },
      { id: 'true', name: 'With Budgets' },
      { id: 'false', name: 'Without Budgets' },
    ],
  },
  funding_type: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'funding_type_id',
    caption: 'Funding Type',
    selectorOptions: selectLookupFundingTypes,
  },
  start_date: {
    defaultShow: true,
    type: 'date-range',
    field: 'start_date',
    caption: 'Date Start',
  },
  end_date: {
    defaultShow: true,
    type: 'date-range',
    field: 'end_date',
    caption: 'Date End',
  },
};

export default searchFields;
